import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { fetchCampaigns, updateCampaignStatus } from '../api/campaign';
import './CampaignList.css';

const CompanyCampaignsPage = () => {
  const { companyId } = useParams();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || `企業ID: ${companyId}`;
  const [campaigns, setCampaigns] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCampaignsData = async () => {
      try {
        const res = await fetchCampaigns(companyId);
        setCampaigns(res || []);
      } catch (error) {
        console.error('キャンペーン情報の取得に失敗:', error);
      }
    };
    fetchCampaignsData();
  }, [companyId]);

  const toggleCampaignStatus = async (campaignId, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await updateCampaignStatus(campaignId, newStatus);
      setCampaigns((prev) =>
        prev.map((c) =>
          c.id === campaignId ? { ...c, is_active: newStatus } : c
        )
      );
    } catch (error) {
      console.error('キャンペーンの状態更新に失敗:', error);
    }
  };

  return (
    <div className="listBody">
      <h2>キャンペーン一覧（{companyName}）</h2>
      <ul>
        {campaigns.length === 0 ? (
          <li>キャンペーンが登録されていません</li>
        ) : (
          campaigns.map((campaign) => (
            <li key={campaign.id} style={{ marginBottom: '0.5rem' }}>
              {campaign.plan_name} ({campaign.campaign_code}) -{' '}
              {campaign.is_active ? '有効' : '無効'}
              <button
                onClick={() =>
                  toggleCampaignStatus(campaign.id, campaign.is_active)
                }
                style={{ marginLeft: '10px', cursor: 'pointer' }}
              >
                {campaign.is_active ? '無効にする' : '有効にする'}
              </button>
            </li>
          ))
        )}
      </ul>
      <button
        type="button"
        style={{ marginTop: '2rem' }}
        onClick={() => navigate('/campaignlist')}
      >
        企業一覧に戻る
      </button>
    </div>
  );
};

export default CompanyCampaignsPage;
